module.exports = __webpack_public_path__ + "nc_static/media/waiting.0242f8b0.svg";